import { SectionMark } from "@/components/section-mark";
import { Link } from "@tanstack/react-router";

const areas: { number: string; title: string; href: string }[] = [
  {
    number: "01",
    title: "Odpowiedzialność i samotność",
    href: "/samotnosc-lidera",
  },
  {
    number: "02",
    title: "Kontrola i delegowanie",
    href: "/delegowanie-zadan",
  },
  {
    number: "03",
    title: "Wypalenie i koszt sukcesu",
    href: "/wypalenie-zawodowe-u-lidera",
  },
  {
    number: "04",
    title: "Decyzje i relacje nie tylko biznesowe",
    href: "/konflikt-ze-wspolnikiem",
  },
];

export function IntroSection() {
  return (
    <section id="wprowadzenie" className="content-visibility-auto border-b border-ink/10 bg-surface">
      <div className="container-page grid gap-7 py-12 md:grid-cols-[0.42fr_1fr] md:gap-12 md:py-16">
        <div>
          <SectionMark number="04" label="Odpowiedzialność" />
        </div>
        <div className="max-w-2xl">
          <h2 className="display-xl text-[1.9rem] md:text-[2.7rem]">
            Psychologia człowieka, który odpowiada za innych
          </h2>
          <div className="mt-8 h-px w-16 bg-coral/60" />
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/90 md:text-xl">
            Przyglądam się temu, jak odpowiedzialność wpływa na decyzje, relacje i
            codzienne funkcjonowanie lidera.
          </p>
        </div>
      </div>

      <div id="dla-kogo" className="container-page scroll-mt-24 pb-12 md:pb-16">
        <ul className="grid gap-px border-y border-ink/10 bg-ink/10 md:grid-cols-2">
          {areas.map((area) => (
            <li key={area.number} className="bg-surface py-8 md:px-8 md:py-10 md:first:pl-0 md:[&:nth-child(3)]:pl-0">
              <span className="text-xs font-medium tracking-[0.14em] text-coral-text">
                {area.number}
              </span>
              <h3 className="serif-display mt-3 text-[1.45rem] leading-snug md:text-[1.75rem]">
                <Link
                  to={area.href}
                  className="border-b border-coral/60 text-ink transition-colors hover:text-coral-text"
                >
                  {area.title}
                </Link>
              </h3>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
